function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import cn from 'clsx';
import { func, number, string, shape } from 'prop-types';
import Button from '../Button/index.jsx';

/**
 * SaveButton component.
 */
const SaveButton = ({
  buttonStates,
  className,
  onClick,
  initialWait,
  intermediateWait,
  ...restProps
}) => {
  const [buttonState, setButtonState] = useState(buttonStates.default);
  const handleClick = async evt => {
    let lastUpdated;
    let newState = buttonStates.saved;

    // Set the "saving" state if the `onClick` doesn't resolve within the `wait` time
    const timer = setTimeout(() => {
      setButtonState(buttonStates.saving);
      lastUpdated = Date.now();
    }, initialWait);
    try {
      await onClick(evt);
    } catch (err) {
      // TODO: error message to be added in future ticket
      newState = buttonStates.default;
    }
    clearTimeout(timer);

    // Set the new state, waiting for at least the `wait` time for the case
    // where we only just switched to the saving state. If the saving state was
    // never switched to this will set the new state right away.
    setTimeout(() => {
      setButtonState(newState);
      setTimeout(() => setButtonState(buttonStates.default), intermediateWait);
    }, intermediateWait - (Date.now() - lastUpdated) || 0);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('save-button', className)
  }, /*#__PURE__*/React.createElement(Button, _extends({
    icon: buttonState.icon,
    iconSize: 20,
    onClick: handleClick
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: 'save-button__text' + (buttonState.text !== buttonStates.default.text ? " save-button__text--saving" : "")
  }, buttonState.text)));
};
SaveButton.defaultProps = {
  className: null,
  onClick: null,
  initialWait: 200,
  intermediateWait: 1000
};
SaveButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Text and icons for the button states */
  buttonStates: shape({
    text: string,
    icon: string
  }).isRequired,
  /** Additional class names to add to the component root. */
  className: string,
  /** On click event handler - this must be an async function, otherwise the
   * switching of button states will not work as expected. */
  onClick: func,
  /** Time to wait before showing the first status change. This is useful to
   * for cases where we only want to show an intermediary "saving" state when an
   * API call, for example, takes more then `initialWait` seconds to resolve. */
  initialWait: number,
  /**
   * Minimum time to delay between changing button states. For the case
   * where we change to the "saving" state and the `onClick` resolves straight
   * after this delay prevents us flashing that intermediary state at the user
   * for too short a time.
   */
  intermediateWait: number
} : {};
export default SaveButton;